import { Tag, TagProps } from '../02-atoms/Tag';

export interface TagsProps {
  /** Tag objects */
  items: TagProps[];
  /** Additional class */
  className?: string;
}

/** List of key, value pairs */
export const Tags = ({ items, className, ...props }: TagsProps) => {
  return (
    <ul className={['tags', className].join(' ')} {...props}>
      {items.map((item, i) => {
        return (
          <li key={i} className="tags__tag">
            <Tag {...item} />
          </li>
        );
      })}
    </ul>
  );
};
